import React from "react";
import Sculp1 from "../../images/about/gall1.jpg";
import Sculp2 from "../../images/about/gall2.jpg";
import Sculp3 from "../../images/about/gall3.jpg";
import Sculp4 from "../../images/about/gall4.jpg";
import Sculp5 from "../../images/about/gall5.jpg";
import Sculp6 from "../../images/about/gall6.jpg";

const images = [
  { src: Sculp1, alt: "Sculpture 1" },
  { src: Sculp2, alt: "Sculpture 2" },
  { src: Sculp3, alt: "Sculpture 3" },
  { src: Sculp4, alt: "Sculpture 4" },
  { src: Sculp5, alt: "Sculpture 5" },
  { src: Sculp6, alt: "Sculpture 6" }, 
];

function ImageGrid() {
  return (
    <section className="sec_pd">
      <div className=" py-4">
       
        <h3 className="text-center mt-5 mb-4 mx-3 pb-2 text-black fs_40">
        Gallery
      </h3>
      <p className="text-center mb-4 mx-3 pb-2 text-black">
          The Gallery is where our curated collection comes to life. It serves as a visual testament to the diversity and beauty of art across different periods and styles. <br />From timeless classics to contemporary masterpieces, each piece in our gallery tells a story, inviting you to explore the rich tapestry of human expression and creativity.
        </p>
        <div className="row g-3 mt-5">
          {images.map((image, index) => (
            <div key={index} className="col-12 col-lg-4 col-md-6 col-sm-6 col-md-4">
              <img
                src={image.src}
                className="img-fluid rounded gallery-img floral-border"
                alt={image.alt}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ImageGrid;
